import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { ConvexReactClient } from "convex/react";
import type { PropsWithChildren } from "react";

import { environment } from "../config/environment";
import { BackendAvailabilityContext } from "./backendAvailability";

const convexClient = environment.convexUrl ? new ConvexReactClient(environment.convexUrl) : null;

export function BackendProvider({ children }: PropsWithChildren) {
  if (!convexClient) {
    return (
      <BackendAvailabilityContext.Provider value={false}>
        {children}
      </BackendAvailabilityContext.Provider>
    );
  }

  return (
    <BackendAvailabilityContext.Provider value>
      <ConvexAuthProvider client={convexClient}>{children}</ConvexAuthProvider>
    </BackendAvailabilityContext.Provider>
  );
}
